import { EventDrivenStore } from '@core/store/eventDrivenStore';
import constants from '@core/utils/constants';
import { Countries } from '../libraries/countries';

class Store extends EventDrivenStore {
  constructor() {
    super(
      'global',
      {
        selectionRequestId: null,
        countryChoices: [],
        activeChoice: null,
        currencySelectionRequestId: null,
        currencyChoices: [],
        activeCurrencyChoice: null,
        isMultiCurrencySelection: false,
        selectedCurrencies: [],
        preselectedCurrencies: [],
        // Country selection state
        selectedCountry: null,
        allCountries: []
      },
      {
        useLocalStorage: true
      }
    );

    // Auto-initialize countries and detect location
    this.initializeCountries();
    this.detectCountryByIP();
  }

  initializeCountries() {
    const allCountries = Countries.get();
    this.state.allCountries = allCountries;
  }

  // Auto-detect country from IP
  async detectCountryByIP() {
    try {
      // Fetch country from IP API
      const response = await fetch('https://ipapi.co/json/');
      if (!response.ok) throw new Error('Failed to fetch location');

      const data = await response.json();
      const countryCode = data.country_code; // e.g., 'BJ', 'FR', 'US'

      if (countryCode) {
        this.selectCountry(countryCode);
        console.log(`Auto-detected country: ${countryCode}`);
      }
    } catch (error) {
      console.log('Could not auto-detect country, will use manual selection');
      // Fallback to Benin if detection fails
      this.selectCountry('BJ');
    }
  }

  selectCountry(countryCode) {
    if (!countryCode) {
      this.state.selectedCountry = null;
      return;
    }

    const country = Countries.find(countryCode);
    if (country) {
      this.state.selectedCountry = country;
    }
  }

  clearCountrySelection() {
    this.state.selectedCountry = null;
  }

  getCountryName() {
    return this.state.selectedCountry?.countryName || 'Tous les pays';
  }

  getCountryFlag() {
    if (!this.state.selectedCountry) return '🌍';
    return this.state.selectedCountry.alpha2Code?.toLowerCase() || '🌍';
  }

  async setupEvents() {
    this.on(constants.EVENTS.COUNTRY.SELECT, (data) => {
      this.state.selectionRequestId = data.id;
      this.state.activeChoice = null;
      this.state.countrySearch = '';
    });

    this.on(constants.EVENTS.COUNTRY.SELECTION_CLICKED, (data) => {
      if (this.state.activeChoice?.countryCode == data.countryCode) {
        this.state.activeChoice = null;
      } else this.state.activeChoice = data;
    });

    this.on(constants.EVENTS.CURRENCY.SELECT, (data) => {
      this.state.currencySelectionRequestId = data.id;
      this.state.activeCurrencyChoice = null;
      this.state.isMultiCurrencySelection = data.multiSelect || false;

      // Handle preselected currencies
      if (data.preselected) {
        this.state.preselectedCurrencies = Array.isArray(data.preselected)
          ? data.preselected
          : [data.preselected];
      } else {
        this.state.preselectedCurrencies = [];
      }

      // Initialize selected currencies based on preselected
      this.state.selectedCurrencies = [...this.state.preselectedCurrencies];
    });

    this.on(constants.EVENTS.CURRENCY.SELECTION_CLICKED, (data) => {
      if (this.state.isMultiCurrencySelection) {
        // Multi-selection mode
        const index = this.state.selectedCurrencies.indexOf(data.code);
        if (index > -1) {
          // Remove from selection
          this.state.selectedCurrencies.splice(index, 1);
        } else {
          // Add to selection
          this.state.selectedCurrencies.push(data.code);
        }
      } else {
        // Single selection mode
        if (this.state.activeCurrencyChoice?.code == data.code) {
          this.state.activeCurrencyChoice = null;
        } else {
          this.state.activeCurrencyChoice = data;
        }
      }
    });

    this.on(constants.EVENTS.CURRENCY.MULTI_SELECT, (enabled) => {
      this.state.isMultiCurrencySelection = enabled;
      if (!enabled) {
        // Reset to single selection mode
        this.state.selectedCurrencies = [];
      }
    });
  }
}

// new Store();
export default Store;
